"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipText = exports.StyledTooltipContent = exports.StyledTooltipButton = exports.StyledTooltip = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledTooltip = exports.StyledTooltip = _styledComponents["default"].div.attrs({
  className: 'fuse-tooltip'
}).withConfig({
  displayName: "styled-tooltip__StyledTooltip",
  componentId: "sc-1xe7qqp-0"
})(["position:absolute;", ""], function (_ref) {
  var indicator = _ref.indicator,
    open = _ref.open,
    zIndex = _ref.zIndex;
  return "\n\t\tpadding: ".concat(_config.arrowPosition[indicator].tooltipWrapper.margin, ";\n\t\tdisplay: ").concat(open ? 'block' : 'none', ";\n\t\tz-index: ").concat(zIndex, ";\n\t");
});
var StyledTooltipContent = exports.StyledTooltipContent = _styledComponents["default"].div.attrs({
  className: 'fuse-tooltip__content',
  'data-testid': 'fuse-tooltip-content'
}).withConfig({
  displayName: "styled-tooltip__StyledTooltipContent",
  componentId: "sc-1xe7qqp-1"
})(["background:var(--color-functional-tintBlack90);border-radius:var(--border-radius-m);box-shadow:var(--elevation-shadow-xxs);display:flex;padding:var(--spacing-global-space2) var(--spacing-global-space3);position:relative;max-height:calc(", ");max-width:calc(", ");width:fit-content;&::after{content:'';border-top:var(--color-global-black) var(--spacing-global-space4) solid;border-left:#0000 solid calc(", " / 2);border-right:#0000 solid calc(", " / 2);display:inline-flex;height:1px;width:1px;position:absolute;", ";}"], _config.tooltipMaxHeight, _config.tooltipMaxWidth, _config.arrowWidth, _config.arrowWidth, function (_ref2) {
  var indicatorCSSOverrides = _ref2.indicatorCSSOverrides,
    indicator = _ref2.indicator,
    zIndex = _ref2.zIndex;
  return "\n\t\t\tz-index: ".concat(zIndex, ";\n\t\t\t/* \tIndicator sets the Tooltip arrow indicator position based on config: bottomLeft, bottomMiddle, bottomRight, left, right, topRight, topMiddle or topLeft. Defaults to bottomLeft */\n\t\t\t").concat(_config.arrowPosition[indicator].arrowIndicator, "\n\t\t\t/* Enables the user to set custom positioning of the arrow indicator based on the above */\n\t\t\t").concat(indicatorCSSOverrides, "\n\t\t");
});
var StyledTooltipText = exports.StyledTooltipText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-tooltip__text',
  color: 'var(--color-global-white)',
  dataTestId: 'fuse-tooltip-text',
  size: 'm2',
  type: 'paragraph'
}).withConfig({
  displayName: "styled-tooltip__StyledTooltipText",
  componentId: "sc-1xe7qqp-2"
})(["align-self:center;display:-webkit-box;line-clamp:3;margin:0;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:3;-webkit-box-orient:vertical;"]);
var StyledTooltipButton = exports.StyledTooltipButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).attrs({
  className: 'fuse-tooltip__close-button'
}).withConfig({
  displayName: "styled-tooltip__StyledTooltipButton",
  componentId: "sc-1xe7qqp-3"
})(["align-self:flex-start;margin-left:var(--spacing-global-space2);&:active .fuse-plain-icon-button__icon,&:focus .fuse-plain-icon-button__icon,&:hover .fuse-plain-icon-button__icon{background:var(--color-global-white);}"]);